import React, {useEffect, useRef, useState} from "react";
import Loader from "./loader";
import {useNavigate} from "react-router-dom";

function ThreeDSecureAuthentication({
                                        applicationId,
                                        returnUrl,
                                        amount,
                                        currency,
                                        merchantReference,
                                        pan,
                                        expiryDate,
                                        cvv
                                    }) {
    const navigate = useNavigate();

    const authenticationFormReference = useRef(null);
    const [isIframeLoaded, setIsIframeLoaded] = useState(false);

    const redirectToErrorPage = (errorMessage) => {
        navigate("/transaction-failed", {
            state: {
                errorRedirectionUrl: "", errorMessage: errorMessage, shopName: ""
            }, replace: true
        });
    }

    useEffect(() => {
        if (applicationId === "" || applicationId === undefined || applicationId === null ||
            returnUrl === "" || returnUrl === undefined || returnUrl === null ||
            amount === "" || amount === undefined || amount === null ||
            currency === "" || currency === undefined || currency === null ||
            merchantReference === "" || merchantReference === undefined || merchantReference === null ||
            pan === "" || pan === undefined || pan === null ||
            expiryDate === "" || expiryDate === undefined || expiryDate === null ||
            cvv === "" || cvv === undefined || cvv === null) {
            return redirectToErrorPage("Internal Error Occurred");
        }

        authenticationFormReference.current.submit();
    }, []);

    return (
        <div className="w-screen h-screen bg-white z-50 fixed inset-0 flex flex-col">
            <div className="h-2 w-full bg-purple animate-pulse"/>
            <div className="flex-1 flex items-center justify-center">
                <div className="w-3/4 h-3/4 relative">
                    <form ref={authenticationFormReference} name="iveri" target="iveri_authenticate"
                          action="https://portal.nedsecure.co.za/threedsecure/EnrollmentInitial" method="post">
                        <input type="hidden" name="ApplicationId" value={applicationId}/>
                        <input type="hidden" name="ReturnUrl" value={returnUrl}/>
                        <input type="hidden" name="Amount" value={amount}/>
                        <input type="hidden" name="Currency" value={currency}/>
                        <input type="hidden" name="MerchantReference" value={merchantReference} id="merchantRef"/>
                        <input type="hidden" name="PAN" value={pan}/>
                        <input type="hidden" name="ExpiryDate" value={expiryDate}/>
                        <input type="hidden" name="CardSecurityCode" value={cvv}/>
                    </form>
                    {!isIframeLoaded && (
                        <div className="absolute inset-0 flex justify-center items-center bg-white">
                            <Loader/>
                        </div>
                    )}

                    <iframe
                        className={`w-full h-full ${isIframeLoaded ? 'visible' : 'invisible'}`}
                        name="iveri_authenticate"
                        title="3D Secure Authentication"
                        onLoad={() => setIsIframeLoaded(true)}
                    />
                </div>
            </div>
        </div>
    );
}

export default ThreeDSecureAuthentication;